import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRequest } from "ahooks";
import { Form, Select, Input, Button, Space } from "antd";
import BasePopup from "./BasePopup";
import Api from "@/service";
import { useGlobalStore } from "@/stores";
import type { ServerItem } from "@/pages/Home/index.d";
import { Message } from "@/components";
import "./index.scss";

interface GameLoginPopupProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  showButton?: boolean;
}

const GameLoginPopup: React.FC<GameLoginPopupProps> = ({
  open,
  onClose,
  onSuccess,
  showButton = true,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { login, setUserInfo } = useGlobalStore();

  // 获取服务器列表
  const { data: serverList = [] } = useRequest(
    async (): Promise<ServerItem[]> => {
      const res = await Api.getServerList();

      return res.data.list || [];
    }
  );

  // 绑定游戏角色
  const { run: bindGameRole } = useRequest(
    async (values: { serverId: number; roleId: number; zenyCount: number }) => {
      const res = await Api.bindGameRole(
        values.serverId,
        values.roleId,
        values.zenyCount
      );
      return res.data;
    },
    {
      manual: true,
      onSuccess: (data: { account_info: any; token: string } | undefined) => {
        if (data) {
          Message.success({ content: t("loginSuccess") });
          // 使用store的login方法设置token
          login(data.token);
          onSuccess();
          onClose();
        }
      },
    }
  );

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      bindGameRole(values);
    } catch (error) {
      // 表单验证失败
      console.error("表单验证失败:", error);
    }
  };

  const handleClose = () => {
    // 重置表单状态
    form.resetFields();

    onClose();
  };

  const formContent = (
    <Form
      form={form}
      layout='vertical'
      initialValues={
        {
          // serverId: 813,
          // roleId: 821501,
          // zenyCount: 300899,
        }
      }>
      <Form.Item label={t("server")} name='serverId'>
        <Select placeholder={t("pleaseSelect")} showSearch>
          {serverList.map((server: ServerItem) => (
            <Select.Option value={server.outer_id} key={server.id}>
              {server.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label={t("text_roleId")} name='roleId'>
        <Input type='number' placeholder={t("onlyNum")} />
      </Form.Item>
      <Form.Item label={t("text_zenyCount")} name='zenyCount'>
        <Input type='number' placeholder={t("onlyNum")} />
      </Form.Item>
    </Form>
  );

  const footer = (
    <Button type='primary' onClick={handleConfirm}>
      {t("confirm")}
    </Button>
  );

  const tips = (
    <div className='tips'>
      <div>{t("text_2")}</div>
    </div>
  );

  return (
    <BasePopup
      open={open}
      onClose={handleClose}
      title={t("validateAccount")}
      footer={footer}
      tips={tips}
      showButton={showButton}>
      {formContent}
    </BasePopup>
  );
};

export default GameLoginPopup;
